module.exports = __webpack_public_path__ + "img/JOMAIH-KV.a876d63b.jpg";